import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const BidderBidsTable = ({ params, report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} key={index} />));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange} params={params} />
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderBidsTable;



// WEBPACK FOOTER //
// ./src/scenes/BidderBids/components/Table/index.js